import StatsCard from "./StatsCard";
import ServiceProviderTable from "./ServiceProviderTable";
import {
  ServiceProvider,
  SummaryStat,
} from "../../../utils/integrationConfigData";

interface OverviewPanelProps {
  stats: SummaryStat[];
  providers: ServiceProvider[];
  onProviderClick?: (provider: ServiceProvider) => void;
  onProviderEdit?: (provider: ServiceProvider) => void;
  hint?: string;
}

const OverviewPanel = ({
  stats,
  providers,
  onProviderClick,
  onProviderEdit,
  hint = "Each service provider has its own CRD, DTR, and PAS configuration. Click a row to open that provider.",
}: OverviewPanelProps) => {
  return (
    <div className="ic-overview-panel">
      <div className="ic-stats-row" aria-label="Integration summary">
        {stats.map((stat) => (
          <StatsCard
            key={stat.id}
            title={stat.title}
            badge={stat.badge}
            icon={stat.icon}
            detail={stat.detail}
          />
        ))}
      </div>

      <p className="ic-section-hint">{hint}</p>

      <ServiceProviderTable
        providers={providers}
        onRowClick={onProviderClick}
        onEditClick={onProviderEdit}
      />
    </div>
  );
};

export default OverviewPanel;
